module.exports = __webpack_public_path__ + "img/09-register-success.ee9ae020.png";